import React from 'react'

export default function CardLayout({children, cardTitle, cardButtons}) {
  return (
      <div className="card card-default">
        {cardTitle &&
        <div style={{rowGap: '0.9rem'}} className="card-header py-2 border-bottom d-flex align-items-center justify-content-between flex-wrap">
          <h5>{cardTitle}</h5>
          {cardButtons}
        </div>}
        <div className="card-body pt-3">
            {children}
        </div>
      </div>
  )
}
